import { InstructionModel, List } from '@partful/instructions-domain-models';
import { BaseService } from '@partful/shared/api/baseService';

export class InstructionsService extends BaseService {
  async create(account: string, configurationId: string): Promise<InstructionModel> {
    const res = await this.client.post(`/instructions`, { configurationId }, { params: { account } });
    return res.data;
  }

  async list(account: string, args: { nextToken?: string; configurationId?: string }): Promise<List<InstructionModel>> {
    const res = await this.client.get<List<InstructionModel>>(`/instructions`, { params: { account, ...args } });
    return res.data;
  }
}
